import { Flex, Space, Typography } from 'antd';
import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

const { Text, Title } = Typography;

interface SectionTitleProps
  extends Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'id'> {
  title: ReactNode;
  subTitle?: ReactNode;
  rightContent?: ReactNode;
}

export function SectionTitle({
  id,
  title,
  subTitle,
  rightContent,
  className,
}: Readonly<SectionTitleProps>) {
  return (
    <Flex
      align="center"
      justify="space-between"
      className={classNames('mb-16', className)}
    >
      <Space direction="vertical">
        <Title id={id} level={2} className="mr-16">
          {title}
        </Title>
        {subTitle && (
          <Text type="secondary" className="text-sm font-semibold">
            {subTitle}
          </Text>
        )}
      </Space>
      {rightContent}
    </Flex>
  );
}
